export default {
    IMAGE: 'image',
    LINK: 'link',
};
